import { RegistryItem } from "@schemas/calculationmethods/schema";
import { CalculationMethodType } from "__generated__/graphql";
import PercentageOnAgreementsCalculationMethodDetails from "view/calculationmethods/components/details/PercentageOnAgreementsCalculationMethodDetails";
import PercentageOnAgreementsCalculationMethodForm from "view/calculationmethods/components/form/PercentageOnAgreementsCalculationMethodForm";
import { isTankmatch } from "components/utils/Permission";
import { hasNegativePercentage } from "view/calculationmethods/utils/NegativeCommissionUtils";

export const PercentageOnAgreementsSchema: RegistryItem = {
	[CalculationMethodType.PercentageOnAgreements]: {
		Form: PercentageOnAgreementsCalculationMethodForm,
		Details: PercentageOnAgreementsCalculationMethodDetails,
		fields: {
			"calculationMethod.percentage": { path: "percentage", rules: { required: true } },
			"calculationMethod.applicableAgreements": {
				path: "applicableAgreements",
				rules: {
					hiddenIf: () => isTankmatch(),
					requiredIf: () => !isTankmatch(),
				},
			},
			"calculationMethod.applicableAgreementTypes": {
				path: "applicableAgreementTypes",
				rules: {
					requiredIf: () => isTankmatch(),
				},
			},
		},
		toInput: (form, agreementType) => ({
			percentageOnAgreementsCalculationMethodInput: {
				id: form.id,
				percentage: hasNegativePercentage(agreementType) && form.percentage != null ? form.percentage * -1 : form.percentage,
				applicableAgreementTypes: form.applicableAgreementTypes ?? [],
				applicableAgreements: form.applicableAgreements?.map(x => ({
					id: x.id,
					uuid: x.uuid,
				})),
			},
		}),
		toForm: (method, agreementType) => ({
			percentage: hasNegativePercentage(agreementType) ? (method.percentage ?? 0) * -1 : method.percentage ?? undefined,
			applicableAgreementTypes: method.applicableAgreementTypes ?? [],
			applicableAgreements: method.applicableAgreements?.map(x => ({
				id: x.id,
				type: x.type,
				description: x.description ?? undefined,
				calculationMethod: null,
			})) ?? [],
		}),
	},
};
